// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { IAssessmentPlanningGetDetailAttrs } from 'interfaces/back-office/assessment/planning/planning-view.interface'

const useAssessmentPlanning = () => {
  // Hook
  const {
    assessmentPlanning: {
      assessmentPlanning_isLoading,
      assessmentPlanning_detail,
      assessmentPlanning_CLEAR_DETAIL,
      assessmentPlanning_fetchDetail: fetchDetail,
    },
  } = useStores()

  /**
   * @description Fetch assessment planning detail
   *
   * @param {IAssessmentPlanningGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentPlanning_fetchDetail = useCallback(
    (payload: IAssessmentPlanningGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  return {
    assessmentPlanning_isLoading,
    assessmentPlanning_detail,
    assessmentPlanning_CLEAR_DETAIL,
    assessmentPlanning_fetchDetail,
  }
}

export { useAssessmentPlanning }
